import React, {
  memo,
} from 'react';
import clsx from 'clsx';

export type Prop = {
  id: string;
  className?: string;
  label?: string;
  required?: boolean;
};

function Label({
  id,
  className,
  label,
  required,
}: Prop) {
  const classes = clsx('populate-label w-fit', className);

  return (
    <label
      htmlFor={id}
      className={classes}
    >
      {label}
      {required && <sup className="text-red-400 !absolute !text-lg -top-1.5 -right-2.5">*</sup>}
    </label>
  );
}

export default memo(Label);
